export enum SwapStatus {
  not_started = 0,
  in_progess = 1,
  complete = 2,
  failed = 3,
  rejected = 4,
  approval_pending = 5,
  confirm_pending = 6,
  wert_inprogress = 7,
}

export const languages = [
  // {
  //   name: "Arabic",
  //   native_name: "عربي",
  //   value: "ar",
  //   flag: "ar",
  // },
  // {
  //   name: "Bulgarian",
  //   native_name: "български",
  //   value: "bg",
  //   flag: "bg",
  // },
  {
    name: 'English',
    native_name: 'English',
    value: 'en',
    flag: 'en',
  },
  // {
  //   name: "Chinese (simplified)",
  //   native_name: "中文（简体）",
  //   value: "zh-hans",
  //   flag: "cn"
  // },
  // {
  //   name: "Chinese (traditional)",
  //   native_name: "中文（繁體）",
  //   value: "zh-hant",
  //   flag: "cn"
  // },
  // {
  //   name: "Czech",
  //   native_name: "čeština",
  //   value: "cs",
  //   flag: "cs"
  // },
  // {
  //   name: "Dutch",
  //   native_name: "Nederlands",
  //   value: "nl",
  //   flag: "nl"
  // },
  // {
  //   name: "Filipino",
  //   native_name: "Filipino",
  //   value: "fil",
  //   flag: "fil"
  // },
  // {
  //   name: "Finnish",
  //   native_name: "suomalainen",
  //   value: "fi",
  //   flag: "fi"
  // },
  // {
  //   name: "French",
  //   native_name: "Français",
  //   value: "fr",
  //   flag: "fr"
  // },
  // {
  //   name: "German",
  //   native_name: "Deutsch",
  //   value: "de",
  //   flag: "de"
  // },
  // {
  //   name: "Greek",
  //   native_name: "ελληνικά",
  //   value: "el",
  //   flag: "el"
  // },
  // {
  //   name: "Hungarian",
  //   native_name: "magyar",
  //   value: "hu",
  //   flag: "hu"
  // },
  // {
  //   name: "Indonesian",
  //   native_name: "Indonesia",
  //   value: "id",
  //   flag: "id"
  // },
  // {
  //   name: "Italian",
  //   native_name: "Italiano",
  //   value: "it",
  //   flag: "it"
  // },
  // {
  //   name: "Japanese",
  //   native_name: "日本語",
  //   value: "ja",
  //   flag: "ja"
  // },
  // {
  //   name: "Korean",
  //   native_name: "한국인",
  //   value: "kr",
  //   flag: "kr"
  // },
  // {
  //   name: "Persian",
  //   native_name: "فارسی",
  //   value: "fa",
  //   flag: "fa"
  // },
  // {
  //   name: "Polish",
  //   native_name: "Polski",
  //   value: "pl",
  //   flag: "pl"
  // },
  // {
  //   name: "Portuguese",
  //   native_name: "Português",
  //   value: "pt",
  //   flag: "pt"
  // },
  // {
  //   name: "Romanian",
  //   native_name: "română",
  //   value: "ro",
  //   flag: "ro"
  // },
  // {
  //   name: "Russian",
  //   native_name: "Русский",
  //   value: "ru",
  //   flag: "ru"
  // },
  // {
  //   name: "Slovak",
  //   native_name: "slovenský",
  //   value: "sk",
  //   flag: "sk"
  // },
  // {
  //   name: "Spanish",
  //   native_name: "Español",
  //   value: "es",
  //   flag: "es"
  // },
  // {
  //   name: "Swedish",
  //   native_name: "svenska",
  //   value: "sv",
  //   flag: "sv"
  // },
  // {
  //   name: "Thai",
  //   native_name: "แบบไทย",
  //   value: "th",
  //   flag: "th"
  // },
  // {
  //   name: "Turkish",
  //   native_name: "Türkçe",
  //   value: "tr",
  //   flag: "tr"
  // },
  // {
  //   name: "Vietnamese",
  //   native_name: "Tiếng Việt",
  //   value: "vi",
  //   flag: "vi"
  // },
];

export const wertLangs: Record<string, string> = {
  en: 'en',
  fr: 'fr',
  ja: 'ja',
  es: 'es',
  kr: 'ko',
  'zh-hans': 'zh',
  'zh-hant': 'zh',
};

export enum CTAStatus {
  none,
  eth,
  usdt,
  transak,
}

export function getCookie(name: string) {
  let matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function getReferrer() {
  if (typeof window == 'undefined') return;

  let urlParams = new URLSearchParams(document.location.search);
  let param: any = getCookie('referrer');
  if (!param || param == '') {
    param = document.referrer;
    document.cookie = 'referrer' + '=' + param + ';max-age=34560000';
  }

  if (urlParams.get('pid') || urlParams.get('tid')) {
    // always take clickId from URL if present
    param = document.referrer;
    document.cookie = 'referrer' + '=' + param + ';max-age=34560000';
  }

  return param ? param : '';
}

export function getParam(paramName: string) {
  if (typeof window == 'undefined') return;
  let urlParams = new URLSearchParams(document.location.search);
  let param: any = getCookie(paramName);

  if (urlParams.get(paramName)) {
    // always take clickId from URL if present
    param = urlParams.get(paramName);
    document.cookie = paramName + '=' + param + ';max-age=15778462';
  }
  return param ? param : '';
}

export function handleLastClickTracking(paramNames: string[]): Record<string, string> {
  const result: Record<string, string> = {};
  if (typeof window === 'undefined') return result;

  const urlParams = new URLSearchParams(document.location.search);
  const hasParamInUrl = paramNames.some((name) => urlParams.has(name));
  // If any tracking param is in the URL — override everything
  if (hasParamInUrl) {
    for (const paramName of paramNames) {
      const value = urlParams.get(paramName) || ''; // set to '' if missing
      document.cookie = `${paramName}=${value}; max-age=15778462; path=/`;
      result[paramName] = value;
    }
  } else {
    // Use cookie values from previous session
    for (const paramName of paramNames) {
      result[paramName] = getCookie(paramName) || '';
    }
  }
  return result;
}

export function getParamWithoutCookie(paramName: string) {
  if (typeof window == 'undefined') return;
  let urlParams = new URLSearchParams(document.location.search);
  let param;
  if (urlParams.get(paramName)) {
    // always take clickId from URL if present
    param = urlParams.get(paramName);
  }

  return param ? param : '';
}

export function getBrowserName() {
  const agent = window.navigator.userAgent.toLowerCase();
  switch (true) {
    case agent.indexOf('edge') > -1:
      return 'edge';
    case agent.indexOf('opr') > -1 && !!(<any>window).opr:
      return 'opera';
    case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
      return 'chrome';
    case agent.indexOf('trident') > -1:
      return 'ie';
    case agent.indexOf('firefox') > -1:
      return 'firefox';
    case agent.indexOf('safari') > -1:
      return 'safari';
    default:
      return 'other';
  }
}

export function verifyLanguage(lang: string): boolean {
  const validLang = languages.filter((x) => x.value === lang);
  return validLang.length > 0 ? true : false;
}

export function convertNum(value: number, decimals: number = 2) {
  const num = Math.floor(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
  let nf = new Intl.NumberFormat('en-US', { maximumFractionDigits: decimals });
  return nf.format(num); // "1,234,567,890"
}

export function convertDecimal(value: number, decimals: number = 2) {
  return Math.floor(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
}
